module.exports = __webpack_public_path__ + "img/Virtual_Community.95fed3bf.png";